import { FC } from 'react'
import { Container } from './TabPanel.style'

interface TabPanelProps {
  activeTab: number
  value: number
}

const TabPanel: FC<TabPanelProps> = ({
  children,
  activeTab,
  value,
  ...props
}) => (
  <Container {...props} hidden={activeTab !== value}>
    {children}
  </Container>
)

export default TabPanel
